import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatCard } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatInput, MatLabel, MatSuffix } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from 'app/shared/components/atoms';
import { ContentHeaderComponent, IContentHeaderConfig } from 'app/shared/components/molecules';
import { ButtonStyle } from 'app/shared/enums';
import { MessagesChatComponent } from '../messages-chat/messages-chat.component';
import { MessagesOverviewComponent } from '../messages-overview/messages-overview.component';

@Component({
  selector: 'app-messaging',
  imports: [
    ContentHeaderComponent,
    ButtonComponent,
    TranslateModule,
    MessagesOverviewComponent,
    MatCard,
    MessagesChatComponent,
    MatInput,
    MatFormField,
    MatLabel,
    MatIcon,
    MatSuffix,
    MatIconButton,
  ],
  templateUrl: './messaging.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessagingComponent {
  protected readonly ButtonStyle = ButtonStyle;

  public headerConfig: IContentHeaderConfig = {
    buttons: [],
  };
}
